import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

/**
 * The UK sales deck's cover photograph, lifted from page 1 at 400dpi and
 * cropped to the right of the deck's mint circle so no deck furniture comes
 * with it — the hero applies its own `rounded-l-full` mask, which happens to
 * be the same shape the slide uses.
 *
 * `objectPosition` is biased above centre because the crop is portrait and the
 * hero slot is short and wide on mobile: dead-centre would frame the shirts
 * rather than the faces.
 */
const ImageUkHero = ({ children, className }) => {
  const data = useStaticQuery(graphql`
    query {
      desktopImage: file(relativePath: { eq: "schools/uk-schools-hero.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      className={className}
      image={getImage(data.desktopImage)}
      style={{
        width: "100%",
        height: "100%",
      }}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "center 25%",
      }}
    >
      {children}
    </GatsbyImage>
  )
}

export default ImageUkHero
